import * as yup from "yup";

const model = {
  tripType: "",
  tripTypeId: 0,
  flightDates: "",
  flightLegs: {
    onward: [
      {
        flightNumber: "",
        airportDepartureId: "",
        airportDestinationId: "",
        flightCarrierId: "",
        checkInBaggage: "",
        fareType: "",
        arrivalTime: "",
        departureTime: "",
      },
    ],
  },
  isPnrRequired: true,
  seats: 1,
  pnr: "",
  refundable: false,
  adultBaseFare: 0,
  adultYQ: 0,
  adultTotalTaxPerSeat: 0,
  childBaseFare: 0,
  childYQ: 0,
  childTotalTaxPerSeat: 0,
  infrantBaseFare: 0,
  infrantYQ: 0,
  infrantTotalTaxPerSeat: 0,
  commEmailOne: "",
  commEmailTwo: "",
};

const validationModel = yup.object().shape({
  tripType: yup.string().optional("Please Select Trip type"),
  //   tripTypeId: yup.string().optional("Please Select Trip ID"),
  flightNumber: yup.string().optional("Please Enter Flight Number"),
  flightDates: yup.string().optional("Please Select Flight Date"),
  seats: yup.number().optional("Please Select Seat"),
  isPnrRequired: yup.boolean().required("Please Select PNR options"),
  //pnr: yup.string().required("please Enter PNR Number"),
  pnr: yup.string().when("isPnrRequired", {
    is: true,
    then: yup.string().required("please Enter PNR Number"),
  }),
  refundable: yup.boolean().optional(),
  tripTypeId: yup.number().optional("Please Select Trip ID"),
  adultBaseFare: yup.number().optional("Please Select Adult Base Fare"),
  adultYQ: yup.number().optional("Please Select Adult YQ"),
  adultTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Adult Total Tax Per Seat"),
  childBaseFare: yup.number().optional("Please Enter Child Total Tax Per Seat"),
  childYQ: yup.number().optional("Please Enter Child YQ"),
  childTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Child Total Tax Per Seat"),
  infrantBaseFare: yup.number().optional("Please Enter Infant Base Fare"),
  infrantYQ: yup.number().optional("Please Enter infant YQ"),
  infrantTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Infant Total Tax Per Seat"),
  commEmailOne: yup
    .string()
    .required("Please enter Person-1 Email")
    .email("Please enter a valid email"),
  commEmailTwo: yup.string().optional().email("Please enter a valid email"),

  flightLegs: yup.object().shape({
    onward: yup
      .array()
      .of(
        yup.object().shape({
          flightNumber: yup.string().required("Please Enter Flight number"),
          airportDepartureId: yup
            .string()
            .required("Please Enter Airport Departure"),
          airportDestinationId: yup
            .string()
            .required("Please Enter Airport Destination"),
          flightCarrierId: yup.number().required("Please Enter Carrier"),
          checkInBaggage: yup
            .string()
            .required("Please Enter Check In Baggage"),
          fareType: yup.string().required("Please Enter Fare Type"),
          arrivalTime: yup.string().required("Please Enter Arrival Time"),
          departureTime: yup.string().required("Please Enter Departure Time"),
        })
      )
      .optional(),
  }),
});

const newValidationSchema = yup.object().shape({
  tripType: yup.string().optional("Please Select Trip type"),
  //   tripTypeId: yup.string().optional("Please Select Trip ID"),
  flightNumber: yup.string().optional("Please Enter Flight Number"),
  flightDates: yup.string().optional("Please Select Flight Date"),
  seats: yup.number().optional("Please Select Seat"),
  isPnrRequired: yup.boolean().required("Please Select PNR options"),
  //  pnr: yup.string().optional("please Enter PNR Number"),
  pnr: yup.string().when("isPnrRequired", {
    is: true,
    then: yup.string().required("please Enter PNR Number"),
  }),
  refundable: yup.boolean().optional(),
  tripTypeId: yup.number().optional("Please Select Trip ID"),
  adultBaseFare: yup.number().optional("Please Select Adult Base Fare"),
  adultYQ: yup.number().optional("Please Select Adult YQ"),
  adultTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Adult Total Tax Per Seat"),
  childBaseFare: yup.number().optional("Please Enter Child Total Tax Per Seat"),
  childYQ: yup.number().optional("Please Enter Child YQ"),
  childTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Child Total Tax Per Seat"),
  infrantBaseFare: yup.number().optional("Please Enter Infant Base Fare"),
  infrantYQ: yup.number().optional("Please Enter infant YQ"),
  infrantTotalTaxPerSeat: yup
    .number()
    .optional("Please Enter Infant Total Tax Per Seat"),
  commEmailOne: yup
    .string()
    .optional("Please enter Person-1 Email")
    .email("Please enter a valid email"),
  commEmailTwo: yup.string().optional().email("Please enter a valid email"),

  flightLegs: yup.object().shape({
    onward: yup
      .array()
      .of(
        yup.object().shape({
          flightNumber: yup.string().required("Please Enter Flight number"),
          airportDepartureId: yup
            .string()
            .required("Please Enter Airport Departure"),
          airportDestinationId: yup
            .string()
            .required("Please Enter Airport Destination"),
          flightCarrierId: yup.number().required("Please Enter Carrier"),
          checkInBaggage: yup
            .string()
            .required("Please Enter Check In Baggage"),
          fareType: yup.string().required("Please Enter Fare Type"),
          arrivalTime: yup.string().required("Please Enter Arrival Time"),
          departureTime: yup.string().required("Please Enter Departure Time"),
        })
      )
      .optional(),

    return: yup
      .array()
      .of(
        yup.object().shape({
          flightNumber: yup.string().required("Please Enter Flight number"),
          airportDepartureId: yup
            .string()
            .required("Please Enter Airport Departure"),
          airportDestinationId: yup
            .string()
            .required("Please Enter Airport Destination"),
          flightCarrierId: yup.number().required("Please Enter Carrier"),
          checkInBaggage: yup
            .string()
            .required("Please Enter Check In Baggage"),
          fareType: yup.string().required("Please Enter Fare Type"),
          arrivalTime: yup.string().required("Please Enter Arrival Time"),
          departureTime: yup.string().required("Please Enter Departure Time"),
        })
      )
      .optional(),
  }),
});

const tripTypeOptions = [
  { value: 1, label: "One Way" },
  // { value: 2, label: "Round Trip" },
  // { value: 3, label: 'Multicity' },
];

export { model, validationModel, tripTypeOptions, newValidationSchema };
